import React from 'react';
// import PropTypes from 'prop-types';
import { DI } from 'modules';
import Component from 'components/component';

export class PlanCardFooter extends Component {

    static propTypes = {}

    static defaultProps = {}

    render() {
        const strings = this.props.common.strings;
        const {
            text = strings['page.plan_details.agreements.contact_info.text']
        } = this.props;

        return (
            <div className="plan-details__footer plan-details-footer">
                <div className="plan-details-footer__text">
                    {text}
                </div>
                <div className="plan-details-contacts">
                    <div className="plan-details-contacts__item">
                        <a className="_phone" href="tel:+49 30 3198 72 300">{strings["page.plan_details.agreements.contact_info.phone"]}</a>
                    </div>
                    <div className="plan-details-contacts__item">
                        <a className="_email" href="mailto:cd@ruptly.tv">{strings["page.plan_details.agreements.contact_info.email"]}</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default DI([])(PlanCardFooter);